import { computed } from "vue";
import { webUrl } from "../../api/config";
import { SERVICE_PHONE } from "../../constants/index";
import { useStore } from "vuex";
import { logout } from "../../utils/utils.js";
import { useRouter } from "vue-router";

export default {
  name: "CommonHeader",
  props: {
    myProject: {
      type: Boolean,
      default: false,
    },
    needLogin: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const router = useRouter();
    const accountList = [];
    const store = useStore();

    const servicePhone = SERVICE_PHONE;
    const userInfo = computed(() => store.state.user.userInfo);

    //工作台跳转
    const linkToWork = (type) => {
      if (type === "purchaser") {
        window.open(`${webUrl.webUrl.purchaseWkpfUrl}`);
      } else {
        window.open(`${webUrl.webUrl.supplierWkpfUrl}`);
      }
    };

    //其他链接跳转到其他web页面
    const linkToTargetWeb = (num) => {
      switch (num) {
        case 0:
          window.open(`${webUrl.webUrl.homeUrl}`);
          break;
        case 1:
          window.open(`${webUrl.webUrl.serviceUrl}/supplierRecruitment`);
          break;
        case 2:
          window.open(`${webUrl.webUrl.serviceUrl}?type=aboutUs`);
          break;
        case 3:
          window.location = `${
            webUrl.webUrl.homeUrl
          }/login?hostUrl=${encodeURIComponent(location.href)}`;
          break;
        default:
          window.open(`${webUrl.webUrl.homeUrl}`);
          break;
      }
    };

    //退出
    const logOut = () => {
      logout();
    };

    // 我的联采项目页面
    const goMineProject = () => {
      if (userInfo.value.customerId) {
        router.push({ path: "/mineProject" });
      } else {
        linkToTargetWeb(3);
      }
    };

    // 返回首页
    const backToHome = () => {
      if (location.pathname !== "/") {
        router.push({ path: "/" });
      }
    };

    return {
      accountList,
      servicePhone,
      userInfo,
      logOut,
      linkToTargetWeb,
      linkToWork,
      goMineProject,
      backToHome,
    };
  },
};
